import config from 'baseConfig/pg/refunds';

import {
  INITIATED_REFUNDS,
  BATCH_REFUNDS,
  AUTO_REFUNDS,
} from 'baseConfig/pg/constants';

export default {
  [INITIATED_REFUNDS]: {
    TABLE_COLUMNS: [
      {
        key: 'refundAddedOn',
        displayName: 'Date & Time',
        width: 0.14,
        tooltip: {
          message: 'Refund Added On',
        },
      },
      ...config[INITIATED_REFUNDS].TABLE_COLUMNS,
    ],
    FILTER_ITEMS: {},
    SEARCH_ITEMS: [],
  },
  [BATCH_REFUNDS]: {
    TABLE_COLUMNS: [
      {
        key: 'createdAt',
        displayName: 'Uploaded At',
        width: 0.08,
        tooltip: {
          message: 'Batch File Added On',
        },
      },
      ...config[BATCH_REFUNDS].TABLE_COLUMNS,
    ],
    FILTER_ITEMS: {},
    SEARCH_ITEMS: [],
  },
  [AUTO_REFUNDS]: {
    TABLE_COLUMNS: [
      {
        key: 'addedOnAuto',
        displayName: 'Date & Time',
        width: 0.14,
        tooltip: {
          message: 'Refund Added On',
        },
      },
      ...config[AUTO_REFUNDS].TABLE_COLUMNS,
    ],
    FILTER_ITEMS: {},
    SEARCH_ITEMS: [],
  },
};
